import { render, staticRenderFns } from "./TableauPermission.vue?vue&type=template&id=3296ecfd&scoped=true&"
import script from "./TableauPermission.vue?vue&type=script&lang=js&"
export * from "./TableauPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3296ecfd",
  null
  
)

export default component.exports